import React from 'react';
import { PromoToggleContainer, PromoToggleLabel, ToggleSwitch } from './FilterBar.styled';

const PromoToggle = ({ isActive, onToggle, isAvailable }) => {
    if (!isAvailable) return null;

    return (
        <PromoToggleContainer>
            <PromoToggleLabel $isActive={isActive}>
                En Promoción
            </PromoToggleLabel>
            <ToggleSwitch
                $isActive={isActive}
                onClick={onToggle}
                role="switch"
                aria-checked={isActive}
                aria-label="Filtrar solo productos en promoción"
            />
        </PromoToggleContainer>
    );
};

export default PromoToggle;
